const FRESH_START_SESSION_KEY = "maip_fresh_start_mode";

type FreshQueryValue = "1" | "true";

const hasFreshQueryParam = (): boolean => {
  if (typeof window === "undefined") return false;
  const v = new URLSearchParams(window.location.search).get("fresh") as FreshQueryValue | null;
  return v === "1" || v === "true";
};

export const isFreshStartMode = (): boolean => {
  if (typeof window === "undefined") return false;
  return hasFreshQueryParam() || sessionStorage.getItem(FRESH_START_SESSION_KEY) === "1";
};

export const enterFreshStartMode = (): void => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(FRESH_START_SESSION_KEY, "1");
};

export const exitFreshStartMode = (): void => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(FRESH_START_SESSION_KEY);
};

export const clearCulturalOnboardingLocalState = (): void => {
  if (typeof window === "undefined") return;
  localStorage.removeItem("cultural-onboarding-progress");
  localStorage.removeItem("cultural-onboarding-reflections");
  localStorage.removeItem("cultural-onboarding-native-language");
  // legacy key from earlier iterations
  localStorage.removeItem("cultural-onboarding-language-selected");
};

export const clearLanguageOnboardingLocalState = (): void => {
  if (typeof window === "undefined") return;
  localStorage.removeItem("preferred_language");
  localStorage.removeItem("language_onboarding_completed");
};
